import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import GridWrapper from './GridWrapper'

const styles = {
  paper: {
    background: 'transparent',
    paddingTop: 10,
    paddingBottom: 10,
  },
}

function Jumbotron(props) {
  const { classes } = props
  return (
    <GridWrapper variant="black">
      <Grid item xs={12}>
        <Paper className={classes.paper} elevation={0}>
          <Typography color="inherit" align="center" variant="body1">
            <FormattedMessage id="footer" values={{ provider: 'Tazpool' }} />
          </Typography>
        </Paper>
      </Grid>
    </GridWrapper>
  )
}

Jumbotron.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Jumbotron)


// WEBPACK FOOTER //
// ./src/components/Footer.js